type AnalyticsParams = Record<string, string | number | boolean>;

export async function logScreenView(
  screenName: string,
  screenClass?: string,
): Promise<void> {
  if (__DEV__) {
    console.debug('[analytics] screen_view', { screenName, screenClass });
  }
}

export async function logEvent(
  name: string,
  params?: AnalyticsParams,
): Promise<void> {
  if (__DEV__) {
    console.debug('[analytics] event', { name, params });
  }
}

export async function setUserId(userId: string | null): Promise<void> {
  if (__DEV__) {
    console.debug('[analytics] setUserId', { userId });
  }
}

export async function setUserProperties(
  properties: Record<string, string | null>,
): Promise<void> {
  if (__DEV__) {
    console.debug('[analytics] setUserProperties', properties);
  }
}

export async function setAnalyticsCollectionEnabled(
  enabled: boolean,
): Promise<void> {
  if (__DEV__) {
    console.debug('[analytics] setAnalyticsCollectionEnabled', { enabled });
  }
}
